// Search keywords for the settings search in SettingsMenu.vue, keyed by 'Component:tab'.
// Keywords are English POS translation keys; { text, focus } also takes the user to the field
// matching the CSS selector. Generated and kept up to date with the update-settings-search
// skill (.claude/skills/update-settings-search); check with scripts/check-settings-search.mjs.

// Brand names and acronyms that read the same in every language. They need no translation
// key: _() returns the text as it is.
export const untranslated = [
  '301', 'Adax', 'Airbnb', 'API', 'BOCA', 'Booking.com', 'Bókun', 'Channex', 'Consent Mode', 'Consent Studio',
  'Cookiebot', 'CSS', 'DNS', 'Edenred', 'Expedia', 'GDPR', 'Google Analytics', 'Google Tag Manager',
  'GTM', 'Iframe', 'Johku Data Service', 'MobilePay', 'Netaxept', 'Nettimökki', 'Nuki', 'Ratna',
  'Retkipaikka', 'Search Console', 'Shipit', 'Vipps', 'Worldline Acceptance', 'X', 'Yale'
]

export default {
  'CompanyProfile:general': [
    { text: 'Business ID', focus: '#companyId' },
    { text: 'Company name', focus: '#companyName' },
    { text: 'Marketing name', focus: '#shopMarketingname' },
    { text: 'Address', focus: '#companyAddress' },
    { text: 'Zip code', focus: '#companyZip' },
    { text: 'Postal code', focus: '#companyZip' },
    { text: 'City', focus: '#companyCity' },
    { text: 'Country', focus: '#customerCountry' },
    { text: 'Phone number', focus: '#companyPhone' },
    'Contact information'
  ],
  'CompanyProfile:billing': [
    { text: 'E-Invoice Address', focus: '#companyEvoice' },
    { text: 'E-Invoice Intermediary', focus: '#customerEvoiceInt' },
    { text: 'Billing email', focus: '#billingEmail' },
    { text: 'Your reference', focus: '#companyYourReference' },
    { text: 'Bank details', focus: '#payOption1Bank' },
    { text: 'IBAN', focus: '#payOption1Iban' },
    { text: 'BIC', focus: '#payOption1Bic' },
    { text: 'Transaction reports', focus: '#selectMonth' },
    'Commission'
  ],
  'CompanyProfile:details': [
    { text: 'Industry', focus: '[data-search="industry"]' },
    { text: 'Short description', focus: '[data-search="short-description"]' },
    { text: 'General description', focus: '[data-search="general-description"]' },
    { text: 'Latitude', focus: '#latitude' },
    { text: 'Longitude', focus: '#longitude' },
    { text: 'Location', focus: '#pickLocationButton' }
  ],
  'CompanyProfile:some': [
    { text: 'Facebook', focus: '[data-search="facebook"]' },
    { text: 'X', focus: '[data-search="x"]' },
    { text: 'Twitter', focus: '[data-search="x"]' },
    { text: 'LinkedIn', focus: '[data-search="linkedin"]' },
    { text: 'Instagram', focus: '[data-search="instagram"]' },
    { text: 'Youtube', focus: '[data-search="youtube"]' }
  ],
  'CompanyProfile:images': [
    { text: 'Profile picture', focus: '#profileupload' },
    { text: 'Favicon', focus: '#profileupload' },
    { text: 'Storefront logo', focus: '#storefrontlogoupload' },
    { text: 'Logo', focus: '#logoupload' },
    { text: 'Main image', focus: '#fileupload' },
    { text: 'Additional images', focus: '[data-search="additional-images"]' },
    { text: 'Gallery', focus: '[data-search="additional-images"]' }
  ],
  'CompanyProfile:account': [
    { text: 'Shop ID', focus: '#shopId' },
    { text: 'Johku Max', focus: '[data-search="johku-max"]' },
    { text: 'Subscription', focus: '[data-search="johku-max"]' },
    { text: 'Extra users', focus: '[data-search="johku-max"]' },
    { text: 'Deactivate Johku', focus: '[data-search="deactivation"]' },
    { text: 'Activate Johku', focus: '[data-search="deactivation"]' },
    { text: 'Contract termination', focus: '[data-search="contract-termination"]' },
    { text: 'Cancel deletion', focus: '[data-search="contract-termination"]' }
  ],
  'Settings:paymentmethods': [
    { text: 'MobilePay', focus: '#headingEighteen' },
    { text: 'Vipps', focus: '#headingEighteen' },
    { text: 'Viva', focus: '#headingNineteen' },
    { text: 'Visma Pay', focus: '#headingNine' },
    { text: 'Netaxept', focus: '#headingSeventeen' },
    { text: 'Paytrail', focus: '#headingSeven' },
    { text: 'Stripe', focus: '#headingEight' },
    { text: 'PayPal', focus: '#headingFour' },
    { text: 'ePassi', focus: '#headingFifteen' },
    { text: 'Edenred', focus: '#headingSixteen' },
    { text: 'Invoice', focus: '#headingThree' },
    { text: 'Open order', focus: '#headingEleven' },
    { text: 'Interest rate', focus: '#interest' },
    { text: 'Next order number', focus: '#orderCounter' },
    { text: 'Next bill number', focus: '#billCounter' },
    { text: 'Currency', focus: '#selectedCurrency' },
    { text: 'VAT', focus: '[data-search="vat-percentages"]' },
    { text: 'Price tiers', focus: '[data-search="price-tiers"]' },
    { text: 'Commissions', focus: '[data-search="commissions"]' },
    'Payment provider'
  ],
  'Settings:paymentplans': [
    'Subscription',
    'Recurring Payment',
    'Advance payment',
    'Final payment',
    'Billing period',
    'Renewals',
    'Payment link'
  ],
  'Settings:vouchers': [
    'Value card',
    'Gift card',
    'Balance',
    'Codes'
  ],
  'Settings:deliverymethods': [
    'Shipping',
    'Delivery costs',
    'Pick-up'
  ],
  'Settings:languages': [
    { text: 'User interface language', focus: '[data-search="ui-language"]' },
    { text: 'Date format', focus: '#dateFormat' },
    { text: 'Time format', focus: '#timeFormat' },
    { text: 'Number format', focus: '#numberFormat' },
    { text: 'Enabled content language versions', focus: '#enabledLanguageVersions' },
    { text: 'Translations', focus: '#enabledLanguageVersions' },
    { text: 'Default version', focus: '#defaultVersion' },
    'Finnish',
    'Swedish',
    'English'
  ],
  'Settings:tags': [
    { text: 'Show labels', focus: '[data-search="show-labels"]' },
    'SEO',
    'Admin tags',
    'Product tags',
    'Order tag',
    'Keywords'
  ],
  'Settings:users': [
    { text: 'Add user', focus: '#addUserButton' },
    'Administrator',
    'POS user',
    'User level',
    'Permissions',
    'API key',
    'Application password',
    'Direct sign-in link',
    { text: 'Log out after inactivity', focus: '[data-search="inactivity-logout"]' },
    { text: 'Inactivity timeout', focus: '[data-search="inactivity-logout"]' }
  ],
  'Settings:other': [
    { text: 'Automated functions', focus: '[data-search="automated-functions"]' },
    { text: 'Mark as processed', focus: '[data-search="automated-functions"]' },
    { text: 'After sales', focus: '[data-search="after-sales"]' },
    { text: 'Google Calendar', focus: '[data-search="google-calendar"]' },
    { text: 'Statistics Finland', focus: '[data-search="statistics-finland"]' },
    { text: 'Accommodation statistics for Statistics Finland', focus: '[data-search="statistics-finland"]' },
    { text: 'Default customer type', focus: '#customerType' },
    { text: 'Private customer', focus: '#customerType' },
    { text: 'Company or organization', focus: '#customerType' },
    { text: 'Reservation timeout', focus: '[data-search="reservation-timeout"]' },
    { text: 'Basket', focus: '[data-search="reservation-timeout"]' },
    { text: 'Disable basket', focus: '[data-search="disable-basket"]' },
    { text: 'Igloohome', focus: '[data-search="igloohome"]' },
    { text: 'Ratna', focus: '[data-search="ratna"]' }
  ],
  'CommunicationSettings:messages': [
    'Delivery terms',
    'Terms and conditions',
    'Cancellation request',
    'Move request'
  ],
  'CommunicationSettings:emails': [
    { text: 'Sender name', focus: '#senderName' },
    { text: 'Sender email', focus: '#senderEmail' }
  ],
  'CommunicationSettings:terms': [
    'New terms'
  ],
  'CommunicationSettings:forms': [
    'New form',
    'Custom questions',
    'Fields'
  ],
  'CommunicationSettings:templates': [
    'New template',
    'POS receipt',
    'POS ticket',
    'PDF value card',
    'BOCA',
    'Receipt',
    'Ticket'
  ],
  'DeliverySettings:deliverymethods': [
    'Shipping',
    'Free shipping',
    'Shipment dimensions',
    'Delivery time',
    'Internal delivery method',
    'Delivery manifest',
    'Igloohome'
  ],
  'DeliverySettings:deliverymethodgroups': [
    'Combined delivery costs'
  ],
  'DeliverySettings:settings': [
    { text: 'Required customer information', focus: '#requiredInformation' },
    { text: 'Customer details', focus: '#requiredInformation' },
    { text: 'Strong authentication', focus: '#requiredInformation' },
    { text: 'Shipit', focus: '[data-search="use-shipit"]' },
    { text: 'Shipit API key', focus: '[data-search="shipit-api-key"]' },
    { text: 'Shipit API secret', focus: '[data-search="shipit-api-secret"]' },
    { text: 'Shipit sender address', focus: '[data-search="shipit-sender-address"]' }
  ],
  'StorefrontSettings:frontpage': [
    { text: 'Main image', focus: '#mainCategory' },
    { text: 'Slideshow order', focus: '#editMainCategoryContainer' },
    { text: 'Front page search', focus: '[data-search="frontpage-search"]' },
    { text: 'Front page description', focus: '[data-search="frontpage-description"]' },
    { text: 'Featured categories', focus: '[data-search="featured-categories"]' },
    { text: 'Category group', focus: '[data-search="featured-categories"]' },
    { text: 'Split rows', focus: '[data-search="featured-categories"]' },
    { text: 'Maximum number of products', focus: '#productLimitMode' }
  ],
  'StorefrontSettings:search': [
    { text: 'Full-text search', focus: '[data-search="full-text-search"]' },
    { text: 'Availability search', focus: '[data-search="availability-search"]' },
    { text: 'Recommended results in the full-text search', focus: '#searchcategory' },
    { text: 'Keywords', focus: '[data-search="search-keywords"]' },
    { text: 'Search bar placeholder', focus: '[data-search="search-bar-placeholder"]' },
    { text: 'Search results title', focus: '[data-search="search-results-title"]' },
    'Search results'
  ],
  'StorefrontSettings:menu': [
    'Categories',
    'Navigation sort',
    'Sort categories alphabetically',
    'Navigation bar'
  ],
  'StorefrontSettings:widgets': [
    'Embed code',
    'Embed script',
    'Product card',
    'Basket',
    'Join sales channel'
  ],
  'StorefrontSettings:metadata': [
    { text: 'SEO', focus: '#newSeoTag' },
    { text: 'SEO Tags', focus: '#newSeoTag' },
    { text: 'Page title', focus: '#frontpagepagetitle' },
    { text: 'Meta description', focus: '#metaDescription' },
    { text: 'Google Analytics', focus: '[data-search="google-analytics"]' },
    { text: 'Google Tag Manager', focus: '[data-search="google-tag-manager"]' },
    { text: 'GTM', focus: '[data-search="google-tag-manager"]' },
    { text: 'Google Maps API key', focus: '[data-search="google-maps-api-key"]' },
    { text: 'Google Site Verification', focus: '#googleSiteVerification' },
    { text: 'Search Console', focus: '#googleSiteVerification' }
  ],
  'StorefrontSettings:layout': [
    { text: 'Profile picture', focus: '[data-search="profile-picture"]' },
    { text: 'Favicon', focus: '[data-search="profile-picture"]' },
    { text: 'Logo', focus: '[data-search="storefront-logo"]' },
    { text: 'Top bar style', focus: '#topBarStyle' },
    { text: 'Main menu', focus: '[data-search="main-menu"]' },
    { text: 'Show merchant registration link in the main menu', focus: '#promotemerchantregistration' },
    { text: 'Page title location', focus: '#pageTitleLocation' },
    { text: 'Product list column count', focus: '#productListColumnCount' },
    { text: 'Footer', focus: '[data-search="footer-description"]' },
    { text: 'Short description of the store', focus: '[data-search="footer-description"]' },
    { text: 'Footer links', focus: '[data-search="footer-links"]' },
    { text: 'Read more', focus: '[data-search="read-more"]' },
    { text: 'Show navigation in footer', focus: '#footernavigation' },
    { text: 'Navigation column count', focus: '#footernavigationcolumns' }
  ],
  'StorefrontSettings:theme': [
    'Color scheme',
    'Fonts and colors',
    'Color selection',
    'Fonts',
    'Background color',
    'Text color',
    'Accent',
    'CSS',
    'Advanced CSS',
    'Preview'
  ],
  'StorefrontSettings:cookiebot': [
    { text: 'Cookiebot', focus: '#cookieBot' },
    { text: 'Consent Studio', focus: '#cookieCS' },
    'Cookies',
    'Cookie consent management',
    'GDPR',
    'Consent Mode'
  ],
  'StorefrontSettings:redirects': [
    'Old address',
    'New address',
    'Changed addresses',
    'Permanent redirect (301)',
    'Temporary redirect (302)',
    'Page not found (404)',
    'Removed page (410)',
    '301'
  ],
  'StorefrontSettings:settings': [
    { text: 'Smart Crop', focus: '#smartCrop' },
    { text: 'Fully enabled with face detection', focus: '#smartCrop' },
    { text: 'Upsell products title', focus: '#upsellTitle' },
    { text: 'Use a code', focus: '#useACodeText' },
    { text: 'Discount codes', focus: '#useACodeText' },
    { text: 'Contact information', focus: '#shopMarketingname' },
    { text: 'Marketing name', focus: '#shopMarketingname' },
    { text: 'Shop phone', focus: '#shopPhone' },
    { text: 'Phone number', focus: '#shopPhone' },
    { text: 'Shop email', focus: '#shopEmail' },
    { text: 'Merchant information', focus: '#hideShopFromLocal' },
    { text: 'Shop title', focus: '#shopTitle' },
    { text: 'Domain name', focus: '#domainName' },
    { text: 'DNS', focus: '#domainName' },
    { text: 'Google Maps API key', focus: '[data-search="maps-api-key"]' },
    { text: 'Storefront type', focus: '#storefrontType' },
    { text: 'External site URL', focus: '#storefrontType' }
  ],
  'CollectionSettings:collections': [
    'Private Sales Channels',
    'Members',
    'User group membership',
    'Access products',
    'Direct URL'
  ],
  'CollectionSettings:groups': [
    'Permissions',
    'Add user group'
  ],
  'CollectionSettings:users': [
    'Invite user',
    'Private sales channel user',
    'User level',
    'Customers'
  ],
  'CollectionSettings:invites': [
    'Send invitation',
    'Pending',
    'Expired',
    'Invited by'
  ],
  'PosSettings:pointsofuse': [
    'Cash register',
    'Cash registers',
    'POS'
  ],
  'PosSettings:userinterfaces': [
    'Payment terminal',
    'Terminal ID',
    'Worldline Acceptance',
    'Viva',
    'Visma Pay',
    'Receipt printer',
    'Ticket printer',
    'External printers',
    'Floating receipt',
    'Self-service UI',
    'Kiosk',
    'Linked browsers',
    'Menu icons',
    'Column tabs',
    'Default layout section'
  ],
  'PosSettings:layouts': [
    'Menu',
    'Column',
    'Add column',
    'Icon'
  ],
  'PosSettings:components': [
    'Button map',
    'Product list',
    'Category list',
    'Pricing list',
    'Receipt',
    'Iframe',
    'Gas Pump',
    'Showtimes'
  ],
  'UiFeatureCatalog:general': [
    'Catalog',
    'Template',
    'Add to another UI'
  ],
  'AccountingSettings:settings': [
    'Netvisor',
    'Accounting settings',
    { text: 'Use Netvisor', focus: '[data-search="use-netvisor"]' },
    { text: 'Netvisor Customer ID', focus: '#netvisorCustomerId' },
    { text: 'Netvisor Organization ID', focus: '#netvisorOrganizationId' },
    { text: 'Netvisor User Key', focus: '#netvisorUserKey' },
    { text: 'Auxiliary business name', focus: '#netvisorSecondName' }
  ],
  'AccountingSettings:briox': [
    'Accounting settings',
    { text: 'Use Briox', focus: '[data-search="use-briox"]' },
    { text: 'Briox Account ID', focus: '#brioxAccountId' },
    { text: 'Briox Authentication Token', focus: '#brioxAppToken' },
    { text: 'Initial data synchronization', focus: '[data-search="briox-sync"]' }
  ],
  'AccountingSettings:nocfo': [
    'Accounting settings',
    { text: 'Use NoCFO', focus: '[data-search="use-nocfo"]' },
    { text: 'Personal Access Token', focus: '#nocfoToken' },
    { text: 'Business slug', focus: '#nocfoBusinessSlug' },
    { text: 'Initial data synchronization', focus: '[data-search="nocfo-sync"]' }
  ],
  'AccountingSettings:dimensions': [
    'Cost center',
    'Dimension',
    { text: 'Import cost objects', focus: '#importDimensions' }
  ],
  'AccountingSettings:accounts': [
    'Chart of accounts',
    { text: 'Import accounts', focus: '#importAccounts' }
  ],
  'AccountingSettings:accountmapping': [
    { text: 'Advance accounts', focus: '[data-search="advance-accounts"]' },
    { text: 'Discounts account', focus: '[data-search="discounts-account"]' },
    { text: 'Zero VAT sales account', focus: '[data-search="zero-vat-account"]' },
    { text: 'Value card accounts', focus: '[data-search="value-card-accounts"]' },
    'Multi-use value card account',
    'Single-use value card account'
  ],
  'SalesChannelSettings:johkusaleschannels': [
    'Commission',
    { text: 'Request access to a Johku-based sales channel', focus: '#addJohkuSalesChannelButton' }
  ],
  'SalesChannelSettings:othersaleschannels': [
    'External Sales Channels',
    'Channex',
    'Channel manager',
    'Booking.com',
    'Airbnb',
    'Expedia',
    'Room Types',
    'Nettimökki',
    'Hotellinx',
    'MyAllocator',
    'Retkipaikka',
    'Bókun',
    'Bokun',
    'GetYourGuide'
  ],
  'SalesChannelSettings:shopsusingyoursaleschannel': [
    { text: 'Invite a Johku merchant to your Sales Channel', focus: '#inviteShopButton' },
    'Requests to Access Your Sales Channel',
    'Modify commission',
    'Rejected requests'
  ],
  'SalesChannelSettings:mysaleschannel': [
    { text: 'Publish this sales channel to other Johku merchants', focus: '#toggleSaleschannel' },
    { text: 'Onboarding', focus: '#toggleOnboarding' },
    { text: 'Johku Data Service', focus: '[data-search="data-service"]' },
    { text: 'Sales channel name', focus: '#saleschannelTitle' },
    { text: 'Customer profile', focus: '[data-search="customer-profile"]' },
    { text: 'Saleschannel tags', focus: '[data-search="saleschannel-tags"]' },
    { text: 'Default commission', focus: '#saleschannelDefaultCommission' }
  ],
  'SmartDeviceSettings:devices': [
    'Lock',
    'Smart Locks (Seam)',
    'Temperature',
    'Heating',
    'Connect to shared devices from another shop'
  ],
  'SmartDeviceSettings:services': [
    'Smart Locks (Seam)',
    'Igloohome',
    'Yale',
    'Ratna',
    'Adax',
    'Nuki',
    'API key'
  ],
  'SmartDeviceSettings:actions': [
    'Smart Device Action',
    'PIN code',
    'Door code'
  ],
  'IssueList:issues': [
    'Error',
    'Warning',
    'Acknowledged issues'
  ],
  'NotificationSchedule:general': [
    'SMS',
    'Reminder',
    'Send time',
    'Recipient'
  ],
  'AuditLog:general': [
    'Change log',
    'Modification history',
    'Session'
  ],
  'MaxArtifactList:general': [
    'SEO audit',
    'Growth audit',
    'Shop health'
  ],
  'MaxSpecList:general': [
    'Needs approval',
    'Scheduled reports'
  ],
  'AnonymizationSettings:general': [
    'GDPR',
    'Personal data',
    { text: 'Anonymize records up to', focus: '[data-search="anonymization-cutoff"]' },
    { text: 'Display mode for anonymized records', focus: '[data-search="anonymization-display-mode"]' },
    { text: 'Customer deletion', focus: '[data-search="customer-deletion"]' }
  ],
  'Admin:general': [
    'Merchant',
    'Shop ID',
    'Company ID',
    'Download Excel file'
  ],
  'AdminCampaigns:general': [
    'Feature flag',
    'Manual campaign',
    'Newest product in a category'
  ],
  'AdminUserAccess:general': [
    'Permissions',
    'User level'
  ],
  'PartnerIntegrationsSettings:general': [
    { text: 'Pending requests', focus: '[data-search="partner-pending"]' },
    { text: 'Connect your integrations', focus: '[data-search="partner-connect"]' },
    { text: 'Active integrations', focus: '[data-search="partner-active"]' },
    'API',
    'Verified by Johku',
    'Permissions'
  ],
  'AdminPartners:general': [
    'Pilot',
    'Ready for review',
    'Create partner'
  ],
  'AdminPartnerApi:general': [
    'API',
    'Endpoints',
    'Message when disabled'
  ]
}
